import React, { useState, useEffect } from 'react';
import { SingleCollapse } from "@/components/";
import { MasterDataGrid } from "@/components/";
import ExpectedResults from './expected-results';
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../../../presenters/screens/followup-subproject.presenter";
import TableErrors from '../../table-errors';
import { Enums } from "@utils";

export interface ISpecificObjetives{
    index: number;
    indicator: any;  
    activities: any;  
    status: any;
    screen?: string;
    dataColumns?: any;
    results: any;
    currentYear: any;
    saveTable: any;
    tableAlerts?: string;
    initialValidate: boolean;
    initialValidateActPlan?: boolean;
    dimensionData?: any;
}

const SpecificObjectives: React.FC<ISpecificObjetives> = ({index, tableAlerts, indicator, status, screen, dataColumns, results, activities, currentYear, saveTable, initialValidate, dimensionData, initialValidateActPlan}: ISpecificObjetives) => {
    const [columns, setColumns] = useState([]);
    const [auxData, setAuxData] = useState(null);
    const view: IFollowupSubproject = {
        state: {
            dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    const getObjetives = () => {     
        const columns = presenter.getIndType1Columns(status, currentYear);
		setColumns(columns)
	}
    
	useEffect(() => {
		if(dataColumns?._values?.length) getObjetives();
	}, [dataColumns, status?.CodigoDimension, status?.EnEdicion]);

    useEffect(() => {
        if((tableAlerts === `${indicator.id}-${index}-objetive` || !tableAlerts || tableAlerts === 'All') && indicator.data && columns) {
			let asd = getAuxData()
            setAuxData(asd)
        }
    }, [indicator.data, tableAlerts, columns, initialValidate]); 

    const handleErrors = (instance?: any, status?: any) => {
        if(status?.CodigoDimension === Enums.FollowupState.followup) return true;
        return presenter.checkReqFields(instance, status)
    }

    const getAuxData = () => {
		return (
            <>
                <TableErrors 
                    initialValidate={initialValidate}
                    checkEmptyValues={(item: any) => presenter.checkEmptyValues(item, status, Enums.IndicatorType.type1)}
                    msgInitialError={presenter.followupLabels.get("completeFrameworkInformation")}
                    tableAlerts={tableAlerts}
                    calculatedGoal={(item: any) => presenter.checkGoal(item, status, currentYear)} 
                    calculatedReqFields={(instance: any) => handleErrors(instance, status)} 
                    calculatedCriteria={(item: any) => presenter.checkCriteriaLineBase(item, status)}
                    gridId={`${indicator.id}-${index}-objetive`} 
                    followupLabels={presenter.followupLabels}
                />
                {(initialValidate && !indicator.data?.length) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.followupLabels.get("alertMinOneIndicatorRequired")}</h6>
                    </div>
                }
                <MasterDataGrid
                    id={`${indicator.id}-${index}-objetive`}
                    dataSource={indicator.data}
                    columns={columns}
                    allowCode={screen}
                    gridTitle={presenter.followupLabels.get("specificObjectivesTitle")}
                    gridHelpId={`tooltip-${indicator.id}-${index}-objetive`}
                    gridHelpText={presenter.followupLabels.get("helpSpecificObjectives")}
                    gridProps={{
                        editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false
                    }}
                    saveTable={saveTable}
                    infoMessage={presenter.followupLabels.get("infoMessage")}
                />
            </>
        )
    }

    return(
        <>
        {(status) ?
            <SingleCollapse
                keepOpen={!!tableAlerts}
                key={index}
                title={indicator.staticTitle}
                description={indicator.name}
                isOpen={(tableAlerts === "All" || initialValidate || initialValidateActPlan) ? true : false}>
                <>
                    {auxData && auxData}
                    <ExpectedResults 
                        initialValidate={initialValidate}
                        initialValidateActPlan={initialValidateActPlan}
                        tableAlerts={tableAlerts}
                        dataColumns={dataColumns}
                        activities={activities}
                        results={results}
                        status={status} 
                        id={indicator.id}   
                        screen={screen}    
                        currentYear={currentYear}   
                        saveTable={saveTable}
                        dimensionData={dimensionData}                 
                    />    
                </>
            </SingleCollapse>
        :
            <></>
        }
        </>
    )
}

export default SpecificObjectives;